module.exports = ""


//////////////////
// WEBPACK FOOTER
// G:/phoneinfo2/phoneinfo/src/app/components/review-by-user/review-by-user.component.html
// module id = ../../../../../src/app/components/review-by-user/review-by-user.component.html
// module chunks = main